import { isEmpty } from 'lodash'

import { Variables } from '.'
import { Schema } from '../../../schema'

export const mapper = ({ id, variantName }: Schema): Variables => ({
  id,
  variantName: isEmpty(variantName) ? null : variantName,
})
